import React, { useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, Clock, Phone, Star, Gamepad2, Baby, Zap, ShieldCheck, PartyPopper, ArrowRight, Waves, Mountain, Mail, Send } from "lucide-react";
import {
  server_post_data,
  save_contact_us,
} from "../ServiceConnection/serviceconnection.js";


// ── Toast ──────────────────────────────────────────────────────────────────────
const showNotification = (message, type = "error") => {
  document.querySelectorAll(".custom-toast").forEach((t) => t.remove());
  const colors = {
    error: "bg-red-500",
    success: "bg-green-500",
    info: "bg-blue-500",
  };
  const toast = document.createElement("div");
  toast.className = `custom-toast fixed top-4 right-4 z-50 px-6 py-3 rounded-lg shadow-lg transform transition-all duration-300 ${colors[type] ?? colors.info} text-white`;
  toast.style.transform = "translateX(400px)";
  toast.innerHTML = `<div class="flex items-center gap-2"><span class="font-medium">${message}</span></div>`;
  document.body.appendChild(toast);
  setTimeout(() => (toast.style.transform = "translateX(0)"), 10);
  setTimeout(() => {
    toast.style.transform = "translateX(400px)";
    setTimeout(() => toast.parentNode?.removeChild(toast), 300);
  }, 3000);
};

const attractions = [
  { Icon: Baby,        title: "Soft Play Zone",    desc: "Padded slides, tunnels, climbing walls & safe structures for little adventurers", color: "bg-fun-pink",   emoji: "🛝" },
  { Icon: Waves,       title: "Ball Pit Paradise",  desc: "Dive into thousands of colorful balls — the ultimate kids' happy place!",         color: "bg-fun-blue",   emoji: "🔵" },
  { Icon: Mountain,    title: "Sand Pit Fun",       desc: "Creative sandpit play area for sensory exploration and building castles",          color: "bg-fun-yellow", emoji: "🏖️" },
  { Icon: Zap,         title: "VR Games",           desc: "Mind-blowing virtual reality experiences and immersive adventures",               color: "bg-fun-purple", emoji: "🎮" },
  { Icon: Gamepad2,    title: "Arcade Zone",        desc: "Latest arcade games, claw machines & skill-based challenges",                     color: "bg-fun-green",  emoji: "🕹️" },
  { Icon: PartyPopper, title: "Birthday Parties",   desc: "Celebrate your child's special day with exclusive party packages!",               color: "bg-fun-orange", emoji: "🎂" },
];

const FloatEmoji = ({ emoji, cls }) => (
  <div className={`pointer-events-none absolute text-3xl md:text-5xl opacity-20 select-none ${cls}`}>{emoji}</div>
);

const ContactForm = () => {
  const [form, setForm] = useState({ name: "", phone: "", message: "" });
  const [error, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const set = (k) => (e) => setForm(p => ({ ...p, [k]: e.target.value }));

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   setSent(true);
  //   setForm({ name: "", phone: "", message: "" });
  //   setTimeout(() => setSent(false), 3000);
  // };

const validate = () => {
  let newErrors = {};

  // Name validation (only alphabets)
  if (!/^[A-Za-z ]+$/.test(form.name)) {
    newErrors.name = "Name should contain only letters";
  }

  // Phone validation (10 digits only)
  if (!/^[0-9]{10}$/.test(form.phone)) {
    newErrors.phone = "Phone number must be 10 digits";
  }

  // Message validation
  if (form.message.trim().length < 5) {
    newErrors.message = "Message must be at least 5 characters";
  }

  setErrors(newErrors);

  return Object.keys(newErrors).length === 0;
};




  const handleSubmit = async (e) => {
  e.preventDefault();
  if (!validate()) {
      showNotification("Please fill all required fields.", "error");
      return;
    }
  setIsSubmitting(true);
  try {
    let fd = new FormData();

    fd.append("full_name", form.name);
    fd.append("phone_number", form.phone);
    fd.append("message", form.message);
    
    const response = await server_post_data(save_contact_us, fd);
    if (response.data.error) {
        showNotification(response.data.message, "error");
      } else {
        showNotification("Message successfully sent!", "success");
        setTimeout(() => window.location.reload(), 3000);
      }
      } catch (error) {
      console.error(error);
      showNotification("An error occurred. Please try again.", "error");
    } finally {
      setIsSubmitting(false);
    }
};

  const inputCls = "w-full rounded-xl border border-white/15 bg-white/10 px-4 py-3 text-white placeholder:text-white/40 outline-none focus:border-fun-pink focus:ring-1 focus:ring-fun-pink";

  return (
    <form onSubmit={handleSubmit} className="mt-6 space-y-4">
      <input type="text"  required placeholder="Your Name"value={form.name}    onChange={set("name")}    className={inputCls} /> {error.name && (
  <p className="text-red-400 text-sm">{error.name}</p>
)}
      <input type="tel"   required placeholder="Phone Number"     value={form.phone}   onChange={set("phone")}  maxLength={10} className={inputCls} /> {error.phone && (
  <p className="text-red-400 text-sm">{error.phone}</p>
)}
      <textarea required  placeholder="Your Message..." rows={3}  value={form.message} onChange={set("message")} className={`${inputCls} resize-none`} /> {error.message && (
  <p className="text-red-400 text-sm">{error.message}</p>
)}
      <button type="submit"
        className="w-full flex items-center justify-center gap-2 rounded-full bg-gradient-to-r from-fun-pink to-fun-purple py-3 text-base font-bold text-white shadow-lg">
        {isSubmitting ? "✅ Message Sent!" : <><Send size={16} /> Send Message</>}
      </button>
    </form>
  );
};

export default function LandingPage() {
  return (
    <div className="min-h-screen flex flex-col overflow-x-hidden">
      {/* NAV */}
      <nav className="sticky top-0 z-50 border-b border-fun-pink/20 bg-white/90 backdrop-blur-xl">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-3">
          <div className="flex items-center gap-2">
            <span className="text-3xl animate-wiggle">🎪</span>
            <div>
              <span className="font-display text-2xl font-bold bg-gradient-to-r from-fun-pink to-fun-blue bg-clip-text text-transparent">Kids Fun</span>
              <span className="ml-1.5 hidden text-xs font-bold uppercase tracking-widest text-fun-purple sm:inline">Factory</span>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <a href="#attractions" className="hidden rounded-full px-3 py-1.5 text-sm font-semibold text-gray-500 hover:bg-pink-50 hover:text-fun-pink sm:inline-block transition-colors">Attractions</a>
            <a href="#location"    className="hidden rounded-full px-3 py-1.5 text-sm font-semibold text-gray-500 hover:bg-blue-50  hover:text-fun-blue  sm:inline-block transition-colors">Visit Us</a>
            <a href="#contact">
              <button className="flex items-center gap-1.5 rounded-full border-2 border-fun-blue px-3 py-1.5 text-sm font-bold text-fun-blue hover:bg-fun-blue hover:text-white transition-colors">
                <Mail size={14} /> Contact Us
              </button>
            </a>
            <a href="tel:+911234567890">
              <button className="flex items-center gap-1.5 rounded-full bg-fun-pink px-3 py-1.5 text-sm font-bold text-white hover:bg-pink-600 transition-colors shadow-md">
                <Phone size={14} /> Call Us
              </button>
            </a>
          </div>
        </div>
      </nav>

      {/* HERO */}
      <section className="relative overflow-hidden bg-gradient-to-br from-pink-50 via-blue-50 to-yellow-50">
        <FloatEmoji emoji="🎈" cls="left-[5%]  top-[10%] animate-float" />
        <FloatEmoji emoji="⭐" cls="right-[8%] top-[15%] animate-bounce-slow" />
        <FloatEmoji emoji="🎠" cls="left-[15%] bottom-[15%] animate-float [animation-delay:2s]" />
        <FloatEmoji emoji="🧸" cls="right-[12%] bottom-[20%] animate-bounce-slow [animation-delay:1s]" />
        <FloatEmoji emoji="🎪" cls="left-[50%] top-[5%] animate-wiggle" />
        <FloatEmoji emoji="🌈" cls="right-[30%] top-[8%] animate-float [animation-delay:3s]" />
        <div className="pointer-events-none absolute -left-32 top-20 h-64 w-64 rounded-full bg-pink-300/20 blur-3xl" />
        <div className="pointer-events-none absolute right-0 top-0  h-80 w-80 rounded-full bg-blue-300/20 blur-3xl" />
        <div className="pointer-events-none absolute bottom-0 left-1/3 h-48 w-48 rounded-full bg-yellow-300/25 blur-3xl" />

        <div className="relative mx-auto max-w-6xl px-6 py-16 md:py-28">
          <div className="max-w-2xl">
            <div className="mb-5 inline-flex items-center gap-2 rounded-full bg-yellow-100 px-5 py-2 text-sm font-bold text-fun-orange">
              <Star size={16} className="fill-fun-yellow text-fun-yellow" /> #Happy Kids = Relaxed Moms
            </div>
            <h1 className="font-display text-5xl font-bold leading-tight text-gray-900 md:text-7xl">
             Time Out for Moms,{" "}
              <span className="bg-gradient-to-r from-fun-pink via-fun-purple to-fun-blue bg-clip-text text-transparent">Play Time for Kids</span>
              {" "}at{" "}
              <span className="bg-gradient-to-r from-fun-yellow to-fun-orange bg-clip-text text-transparent">Kids Fun Factory 🎉</span>
            </h1>
            <p className="mt-5 text-lg font-medium text-gray-500 md:text-xl">
              🏰 Soft play zone • 🛝 Slides • 🔵 Ball Pit • 🏖️ Sand Pit • 🎮 VR Games • 🕹️ Arcade —
              all under one roof at <strong className="text-gray-900">DB City Mall, Bhopal!</strong>
            </p>
            <div className="mt-8 flex flex-wrap gap-4">
              <a href="#attractions">
                <button className="flex items-center gap-2 rounded-full bg-gradient-to-r from-fun-pink to-fun-purple px-6 py-3 text-lg font-bold text-white shadow-xl hover:opacity-90 transition-opacity">
                  Explore Fun! <ArrowRight size={20} />
                </button>
              </a>
              <a href="#location">
                <button className="flex items-center gap-2 rounded-full border-2 border-fun-blue px-6 py-3 text-lg font-bold text-fun-blue hover:bg-fun-blue hover:text-white transition-colors">
                  <MapPin size={20} /> Find Us
                </button>
              </a>
            </div>
          </div>
          <div className="hidden md:block absolute right-8 top-1/2 -translate-y-1/2">
            <div className="relative h-72 w-72">
              <span className="absolute left-0 top-0 text-7xl animate-bounce-slow">🛝</span>
              <span className="absolute right-4 top-8 text-6xl animate-float">🎈</span>
              <span className="absolute left-8 bottom-8 text-6xl animate-wiggle">🎮</span>
              <span className="absolute right-0 bottom-0 text-7xl animate-bounce-slow [animation-delay:1s]">🏖️</span>
              <span className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-8xl animate-float [animation-delay:2s]">🎪</span>
            </div>
          </div>
        </div>
        <div className="h-16 w-full">
          <svg viewBox="0 0 1440 64" fill="none" xmlns="http://www.w3.org/2000/svg" className="h-full w-full" preserveAspectRatio="none">
            <path d="M0 32C240 64 480 0 720 32C960 64 1200 0 1440 32V64H0V32Z" fill="white" />
          </svg>
        </div>
      </section>

      {/* ACTIVITY PILLS */}
      <section className="py-8 bg-white">
        <div className="mx-auto max-w-5xl px-6">
          <div className="flex flex-wrap justify-center gap-3">
            {["🛝 Slides","🔵 Ball Pit","🏖️ Sand Pit","🎮 VR Games","🕹️ Arcade","🚗 Bumper Cars","🎳 Bowling"].map(item => (
              <span key={item} className="rounded-full border-2 border-pink-100 bg-pink-50 px-4 py-2 text-sm font-bold text-gray-800 transition-all hover:border-fun-pink hover:bg-pink-100 hover:scale-105 cursor-default">
                {item}
              </span>
            ))}
          </div>
        </div>
      </section>

      {/* ATTRACTIONS */}
      <section id="attractions" className="py-20 bg-gradient-to-b from-white to-blue-50">
        <div className="mx-auto max-w-6xl px-6">
          <div className="mb-14 text-center">
            <span className="text-4xl">🎡</span>
            <h2 className="mt-2 font-display text-4xl font-bold text-gray-900">Our Attractions</h2>
            <p className="mt-2 text-lg font-medium text-gray-500">Something exciting for every age group!</p>
          </div>
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {attractions.map(({ Icon, title, desc, color, emoji }) => (
              <div key={title} className="group relative overflow-hidden rounded-2xl border-2 border-transparent bg-white shadow-lg transition-all hover:shadow-2xl hover:-translate-y-1 hover:border-pink-200">
                <div className={`absolute inset-x-0 top-0 h-1.5 ${color}`} />
                <div className="flex flex-col items-center p-7 text-center">
                  <span className="mb-3 text-5xl">{emoji}</span>
                  <div className={`mb-3 flex h-12 w-12 items-center justify-center rounded-2xl ${color} text-white transition-transform group-hover:scale-110 group-hover:rotate-3`}>
                    <Icon size={24} />
                  </div>
                  <h3 className="font-display text-xl font-bold text-gray-900">{title}</h3>
                  <p className="mt-2 text-sm text-gray-500 leading-relaxed">{desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* WHY US */}
      <section className="py-20 bg-gradient-to-r from-pink-50 via-purple-50 to-blue-50">
        <div className="mx-auto max-w-6xl px-6">
          <div className="mb-12 text-center">
            <span className="text-4xl">✨</span>
            <h2 className="mt-2 font-display text-3xl font-bold text-gray-900">Why Parents Love Us</h2>
          </div>
          <div className="grid gap-8 md:grid-cols-3">
            {[
              { icon: <ShieldCheck size={32} className="text-fun-green" />, bg: "bg-green-100", border: "border-green-200", title: "100% Safe & Clean", desc: "Child-safe equipment, sanitized daily, trained staff supervision at all times. 🧹" },
              { icon: <Clock       size={32} className="text-fun-blue"  />, bg: "bg-blue-100",  border: "border-blue-200",  title: "Open 7 Days a Week", desc: "11:00 AM — 9:00 PM daily. Walk in anytime, no booking needed! 🕐" },
              { icon: <Star        size={32} className="fill-fun-yellow text-fun-yellow" />, bg: "bg-yellow-100", border: "border-yellow-200", title: "Top Rated ⭐", desc: "4.5★ on Google with 2000+ reviews. Bhopal's #1 family entertainment spot!" },
            ].map(({ icon, bg, border, title, desc }) => (
              <div key={title} className={`rounded-2xl bg-white p-6 shadow-md border-2 ${border} text-center`}>
                <div className={`mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full ${bg}`}>{icon}</div>
                <h3 className="font-display text-lg font-bold text-gray-900">{title}</h3>
                <p className="mt-2 text-sm text-gray-500">{desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* LOCATION */}
<section id="location" className="py-20 bg-gradient-to-b from-blue-50 to-white">
  <div className="mx-auto max-w-6xl px-6">

    <div className="mb-10 text-center">
      <span className="text-4xl">📍</span>
      <h2 className="mt-2 font-display text-3xl font-bold text-gray-900">
        Come Visit Us!
      </h2>
    </div>

    <div className="mx-auto max-w-lg rounded-3xl bg-white p-8 text-center shadow-xl border-2 border-pink-100">

      <div className="mx-auto mb-5 flex h-20 w-20 items-center justify-center rounded-full bg-gradient-to-br from-fun-pink to-fun-purple">
        <MapPin size={40} className="text-white" />
      </div>

      <h3 className="font-display text-2xl font-bold text-gray-900">
        Kids Fun Factory 🎪
      </h3>

      <p className="mt-3 text-lg font-medium text-gray-500">
        Kids Fun Factory <br/>
        2nd Floor DB City Mall <br/>
        M.P. Nagar Bhopal - 462011
      </p>

      <div className="mt-4 inline-flex items-center gap-2 rounded-full bg-blue-50 px-4 py-2 text-sm font-bold text-fun-blue">
        <Clock size={16} /> Open Daily: 11 AM – 9 PM
      </div>

      <div className="mt-6">

        <a
          href="https://maps.app.goo.gl/RAtpwsHGgHZ7T18H7"
          target="_blank"
          rel="noopener noreferrer"
        >

          <button className="flex items-center gap-2 mx-auto rounded-full bg-gradient-to-r from-fun-blue to-fun-purple px-8 py-3 text-white font-bold shadow-lg hover:opacity-90 transition-opacity">
            <MapPin size={16} /> Get Directions 🗺️
          </button>

        </a>

      </div>

    </div>

  </div>
</section>
{/* CONTACT */}
<section id="contact" className="bg-[#1a1040] py-16 text-white">
  <div className="mx-auto max-w-6xl px-6">
    <div className="grid gap-12 md:grid-cols-2">

      {/* CONTACT FORM */}
      <div>
        <span className="text-3xl">📩</span>
        <h2 className="mt-2 font-display text-3xl font-bold">Contact Us</h2>
        <p className="mt-2 text-white/60 font-medium">
          Have questions? We'd love to hear from you!
        </p>

        <ContactForm />
      </div>

      {/* CONTACT DETAILS */}
      <div className="space-y-6">

        <div>
          <h3 className="font-display text-xl font-bold">
            Kids Fun Factory 🎪
          </h3>

          <p className="mt-2 text-white/70">
            Kids Fun Factory <br/>
            2nd Floor DB City Mall <br/>
            M.P. Nagar Bhopal - 462011
          </p>
        </div>

        {[
          {
             bg: "bg-pink-900",
             icon: <Phone size={20} className="text-fun-pink" />,
             label: "Call Us",
             href: "tel:+911234567890",
             text: "+91 7987014832",
             hoverCls: "hover:text-fun-pink"
          },
          {
            bg: "bg-blue-900",
            icon: <Mail size={20} className="text-fun-blue" />,
            label: "Email Us",
            href: "mailto:kidsfunfactory2024@gmail.com",
            text: "kidsfunfactory2024@gmail.com",
            hoverCls: "hover:text-fun-blue"
          },
          {
            bg: "bg-yellow-900",
            icon: <Clock size={20} className="text-fun-yellow" />,
            label: "Open Hours",
            href: null,
            text: "11:00 AM – 9:00 PM (Daily)",
            hoverCls: ""
          },
          {
            bg: "bg-green-900",
            icon: <MapPin size={20} className="text-fun-green" />,
            label: "Location",
            href: "https://maps.app.goo.gl/RAtpwsHGgHZ7T18H7",
            text: "View Google Map Location →",
            hoverCls: "hover:text-fun-green"
          }
        ].map(({ bg, icon, label, href, text, hoverCls }) => (
          <div key={label} className="flex items-center gap-3">

            <div className={`flex h-10 w-10 items-center justify-center rounded-full ${bg}`}>
              {icon}
            </div>

            <div>
              <p className="text-xs text-white/50">{label}</p>

              {href ? (
                <a
                  href={href}
                  target={href.startsWith("http") ? "_blank" : undefined}
                  rel="noopener noreferrer"
                  className={`font-bold transition-colors ${hoverCls}`}
                >
                  {text}
                </a>
              ) : (
                <p className="font-bold">{text}</p>
              )}

            </div>

          </div>
        ))}

      </div>

    </div>
  </div>
</section>

      {/* FOOTER */}
      <footer className="bg-[#120c30] py-6 text-white">
        <div className="mx-auto flex max-w-6xl flex-col items-center gap-4 px-6 md:flex-row md:justify-between">
          <div className="flex items-center gap-2">
            <span className="text-xl">🎪</span>
            <span className="font-display text-lg font-bold">Kids Fun Factory</span>
          </div>
          <p className="text-xs text-white/40">© {new Date().getFullYear()}Kids Fun Factory. All rights reserved.</p>
          <Link to="/login">
            <button className="flex items-center gap-2 rounded-full border border-pink-500/40 bg-pink-500/20 px-4 py-1.5 text-sm text-white hover:bg-pink-500/40 transition-colors">
              🔒 Admin Login
            </button>
          </Link>
        </div>
      </footer>
    </div>
  );
}